<template>
  <div class="flex flex-col py-4">

    <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="space-between">
      <h4>Detalhes Profissionais</h4>

      <vs-button
        class="ml-2 mobile-hidden"
        size="small" 
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'edit-professional-details' })">
        Editar
      </vs-button>

      <vs-button
        class="ml-2 sm:hidden"
        size="small" 
        color="primary"
        type="border"
        icon="edit"
        @click="$router.push({ name: 'edit-professional-details' })"
      />
    </vs-col>

    
    <hr class="my-4 line"/>

    <div class="flex w-full">
      <div v-if="show()" class="flex flex-col">

        <div class="flex items-center pl-1 my-1" v-if="professional_profile.available">
          <feather-icon :svgClasses="icon_avaliable_color" :icon="icon_avaliable" /><b class="ml-1">Disponível para novas oportunidades</b>
        </div>

        <div class="flex items-center pl-1 my-1" v-if="professional_profile.remote">
          <feather-icon :svgClasses="icon_remote_color" :icon="icon_remote" /><b class="ml-1">Disponível para trabalho remoto</b>
        </div>

        <div class="flex items-center pl-1 my-1" v-if="professional_profile.relocation">
          <feather-icon :svgClasses="icon_relocation_color" :icon="icon_relocation" /><b class="ml-1">Disponível para viajar a trabalho</b>
        </div>

        <div class="flex pl-1 my-1 ml-8" v-if="professional_profile.regimes">
         <p><b>Regime de Contratação:</b> {{ professional_profile.regimes }}</p>
        </div>

        <div class="flex pl-1 my-1 ml-8" v-if="professional_profile.intended_remuneration">
          <p><b>Pretensão Salárial:</b> {{ professional_profile.intended_remuneration }}</p>
        </div>

        <div class="flex pl-1 my-1 ml-8" v-if="showTalent() && talent.facebook_url">
          <p><b>Facebook:</b> {{ talent.facebook_url }}</p>
        </div>

        <div class="flex pl-1 my-1 ml-8" v-if="showTalent() && talent.linkedin_url">
          <p><b>LinkedIn:</b> {{ talent.linkedin_url }}</p>
        </div>

        <div class="flex pl-1 my-1 ml-8" v-if="showTalent() && talent.website_url">
          <p><b>Website:</b> {{ talent.website_url }}</p>
        </div>

        <div class="flex pl-1 my-1 ml-8" v-if="showTalent() && talent.github_url">
          <p><b>Github</b>: {{ talent.github_url }}</p>
        </div>

      </div>
      <div
        class="flex items-center justify-center w-full"
        v-else
      >
        <EmptyDetailCard
          description="Você ainda não preencheu nenhuma informação de detalhe profissional..."
        />
      </div>
    </div>


  </div>
</template>

<script>
import { mapState } from 'vuex';

import EmptyDetailCard from '@/components/dashboard/profile-detail/EmptyDetailCard';

export default {
  computed: {
    ...mapState('professional_profile', ['professional_profile']),
    ...mapState('talent', ['talent']),

    icon_avaliable() {
      return this.professional_profile.available == 'Sim' ||
             this.professional_profile.available == true ||
             this.professional_profile.available == 'Yes' ? 'CheckIcon' : 'XIcon'
    },

    icon_remote() {
      return this.professional_profile.remote == 'Sim' ||
             this.professional_profile.remote == true ||
             this.professional_profile.remote == 'Yes' ? 'CheckIcon' : 'XIcon'
    },

    icon_relocation() {
      return this.professional_profile.relocation == 'Sim' ||
             this.professional_profile.relocation == true ||
             this.professional_profile.relocation == 'Yes' ? 'CheckIcon' : 'XIcon'
    },

    icon_avaliable_color() {
      return this.professional_profile.available == 'Sim' ||
             this.professional_profile.available == true  ||
             this.professional_profile.available == 'Yes' ? 'text-success' : 'text-danger'
    },

    icon_remote_color() {
      return this.professional_profile.remote == 'Sim' ||
             this.professional_profile.remote == true ||
             this.professional_profile.remote == 'Yes' ? 'text-success' : 'text-danger'
    },

    icon_relocation_color() {
      return this.professional_profile.relocation == 'Sim' ||
             this.professional_profile.relocation == true ||
             this.professional_profile.relocation == 'Yes' ? 'text-success' : 'text-danger'
    },


  },
  methods: {
    showTalent() {
      return Object.keys(this.talent).length > 0
    },
    
    show() {
      return Object.keys(this.professional_profile)
                   .filter(key => this.professional_profile[key] != null).length > 5
    }
  },

  components: {
    EmptyDetailCard
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/talent/components/professionalprofilecard.scss';

hr{
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
}
</style>